import { useState } from "preact/hooks";
import { JSX } from "preact/jsx-runtime";
import css from "./Tabs.module.scss";

export interface TabItem {
  id: string;
  label: string;
  disabled?: boolean;
}

export interface TabsProps {
  tabs: TabItem[];
  activeTab?: string;
  defaultActiveTab?: string;
  onTabChange?: (tabId: string) => void;
  className?: string;
  classNameBody?: string;
  variant?: "border" | "default";
}

export const Tabs = ({
  tabs,
  activeTab: controlledActiveTab,
  defaultActiveTab,
  onTabChange,
  variant = "default",
  className = "",
  classNameBody = "",
}: TabsProps): JSX.Element => {
  const [internalActiveTab, setInternalActiveTab] = useState(
    controlledActiveTab || defaultActiveTab || tabs[0]?.id || ""
  );

  const activeTab = controlledActiveTab || internalActiveTab;

  const handleTabClick = (tabId: string) => {
    if (tabs.find((tab) => tab.id === tabId)?.disabled) {
      return;
    }

    if (!controlledActiveTab) {
      setInternalActiveTab(tabId);
    }
    onTabChange?.(tabId);
  };
  const stylesByVariant = {
    border: css.tabBorder,
    default: css.tabHeaders,
  };
  const styleByVariant = stylesByVariant[variant];
  return (
    <div className={`${css.tabs} ${className}`}>
      <div className={`${styleByVariant} ${classNameBody}`}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`${css.tabHeader} ${
              activeTab === tab.id ? css.active : ""
            } ${tab.disabled ? css.disabled : ""}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};
